function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

var _excluded = ["showFirst", "showPrevious", "showNext", "showLast", "padding", "totalPages", "translations"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { usePagination } from 'react-instantsearch-core';
import { Pagination as PaginationUiComponent } from "../ui/Pagination.js";
export function Pagination(_ref) {
  var showFirst = _ref.showFirst,
      showPrevious = _ref.showPrevious,
      showNext = _ref.showNext,
      showLast = _ref.showLast,
      padding = _ref.padding,
      totalPages = _ref.totalPages,
      translations = _ref.translations,
      props = _objectWithoutProperties(_ref, _excluded);

  var _usePagination = usePagination({
    padding: padding,
    totalPages: totalPages
  }, {
    $$widgetType: 'ais.pagination'
  }),
      pages = _usePagination.pages,
      currentRefinement = _usePagination.currentRefinement,
      isFirstPage = _usePagination.isFirstPage,
      isLastPage = _usePagination.isLastPage,
      nbPages = _usePagination.nbPages,
      createURL = _usePagination.createURL,
      refine = _usePagination.refine;

  var uiProps = {
    pages: pages,
    currentPage: currentRefinement,
    isFirstPage: isFirstPage,
    isLastPage: isLastPage,
    nbPages: nbPages,
    createURL: createURL,
    onNavigate: refine,
    translations: _objectSpread({
      firstPageItemText: '‹‹',
      previousPageItemText: '‹',
      nextPageItemText: '›',
      lastPageItemText: '››',
      pageItemText: function pageItemText(_ref2) {
        var currentPage = _ref2.currentPage;
        return String(currentPage);
      },
      firstPageItemAriaLabel: 'First Page',
      previousPageItemAriaLabel: 'Previous Page',
      nextPageItemAriaLabel: 'Next Page',
      lastPageItemAriaLabel: "Last Page, Page ".concat(nbPages),
      pageItemAriaLabel: function pageItemAriaLabel(_ref3) {
        var currentPage = _ref3.currentPage;
        return "Page ".concat(currentPage);
      }
    }, translations)
  };
  return /*#__PURE__*/React.createElement(PaginationUiComponent, _extends({}, props, uiProps, {
    showFirst: showFirst,
    showPrevious: showPrevious,
    showNext: showNext,
    showLast: showLast
  }));
}